var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 32.613 26.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.728,26.652c.053-.009.106-.018.181-.03-.037-.007-.054-.013-.072-.014-.895-.071-1.661-.444-2.337-1.014-.562-.474-.966-1.066-1.227-1.749C.081,23.345.002,22.819.002,22.282c0-1.871,0-3.742,0-5.612C0,15.1,0,13.53,0,11.96c0-.332.047-.656.251-.93.358-.481.832-.734,1.44-.647.608.087.999.457,1.196,1.025.06.173.074.369.074.554.004,3.467.004,6.934,0,10.401,0,.241.059.459.185.656.286.445.681.698,1.228.671.095-.005.191-.003.286-.003,7.768,0,15.535,0,23.303,0,.202,0,.408.012.604-.024.513-.094.966-.575,1.052-1.089.008-.048.007-.098.007-.147,0-3.525,0-7.05,0-10.575,0-.814.649-1.475,1.463-1.488.718-.012,1.355.517,1.467,1.225.019.119.012.242.012.363,0,3.392,0,6.784,0,10.176,0,.162.004.324-.001.485-.022.673-.222,1.296-.56,1.872-.644,1.098-1.597,1.781-2.835,2.068-.081.019-.164.035-.248.042-.08.007-.162.002-.244.016.05.013.099.026.149.039H3.728Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.613,22.488c-.005-.063-.014-.126-.014-.188-.001-2.376-.002-4.753-.002-7.129,0-1.07,0-2.139,0-3.209,0-.042.01-.085.016-.127v10.653Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.819,5.047c-.054.049-.095.082-.132.119-.622.625-1.243,1.252-1.867,1.876-.094.094-.19.188-.296.266-.603.446-1.46.343-1.957-.23-.537-.619-.509-1.453.077-2.048,1.027-1.042,2.061-2.078,3.089-3.12.483-.49.96-.987,1.441-1.478.03-.031.076-.046.115-.067.033-.017.07-.028.099-.05.621-.46,1.415-.414,1.97.13.651.638,1.291,1.286,1.936,1.929.847.846,1.692,1.694,2.542,2.538.225.224.414.467.503.776.252.871-.306,1.746-1.204,1.877-.492.072-.921-.072-1.273-.426-.675-.679-1.348-1.36-2.022-2.039-.014-.014-.03-.024-.062-.048-.002.045-.005.074-.005.103.001,2.31.003,4.621.004,6.931,0,1.845,0,3.69.002,5.535,0,.415-.093.797-.367,1.119-.641.755-1.868.646-2.372-.204-.16-.27-.225-.558-.225-.868.001-3.1,0-6.199.001-9.299,0-1.044.002-2.088.003-3.131,0-.054,0-.108,0-.19Z",
    fill: "currentColor"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.12e37557.svg";
export { ForwardRef as ReactComponent };